import type { ChatEntryWithSubTables } from "../../../shared/aiSdkMessages";
import { type ChatOutputFile, chatOutputFile } from "../../tools/ShowOutput";
import type { IconName } from "../Icon";

export type ChatOutput = ChatOutputFile & {
  entryId: string;
  toolName: string;
};

export function deriveChatOutputs(
  entries: readonly ChatEntryWithSubTables[]
): ChatOutput[] {
  const seen = new Set<string>();
  const outputs: ChatOutput[] = [];
  for (const entry of [...entries].reverse()) {
    if (entry.entryType !== "AssistantToolUse") continue;
    const toolCall = entry.toolCall;
    if (!toolCall || toolCall.completedAt == null || toolCall.isError) continue;
    const file = chatOutputFile(toolCall.toolName, toolCall.input);
    if (!file || seen.has(file.key)) continue;
    seen.add(file.key);
    outputs.push({ ...file, entryId: entry.id, toolName: toolCall.toolName });
  }
  return outputs;
}

export function iconForFileName(fileName: string): IconName {
  switch (fileName.split(".").pop()?.toLowerCase()) {
    case "pdf":
      return "file-scan";
    case "csv":
    case "tsv":
    case "xls":
    case "xlsx":
      return "table";
    case "doc":
    case "docx":
      return "notebook-text";
    case "ppt":
    case "pptx":
      return "gallery-vertical-end";
    case "db":
    case "sqlite":
      return "database";
    default:
      return "paperclip";
  }
}
